import Vue from 'vue';
import moment from "moment";

const state = {
  searchInput: 'koala',
  tabs: {
    selected: {
      label: 'All Results',
      numberOfResults: 0,
      queryStringParam: 'f.Tabs%7CAllDocumentsFill=All+Results'
    },
    selection: [
      {
        label: 'All Results',
        numberOfResults: 0
      }, {
        label: 'Website',
        numberOfResults: 0
      }, {
        label: 'News',
        numberOfResults: 0
      }, {
        label: 'FAQs',
        numberOfResults: 0
      }, {
        label: 'Social Media',
        numberOfResults: 0
      }
    ],
  },

  options: {
    totalResults: 0,
    selectedLimit: 10,
    limits: [10, 25, 50],
    indexStart: 1,
    indexEnd: 10,
    currentPage: 1,
    selectedSort: {
      label: 'Relevance',
      type: ''
    },
    sorts: [{
      label: 'Relevance',
      type: ''
    }, {
      label: 'Date (Newest first)',
      type: 'date'
    }, {
      label: 'Date (Oldest first)',
      type: 'adate'
    }, {
      label: 'Title (A-Z)',
      type: 'title'
    }, {
      label: 'Title (Z-A)',
      type: 'atitle'
    }]
  },

  filters: {
    selected: [],
    selection: []
  },

  results: [],

  relatedSearches: []
};

const getters = {
  searchInput: () => state.searchInput,
  selectedSort: () => state.options.selectedSort,
  selectedLimit: () => state.options.selectedLimit
};

const mutations = {
  setSearchInput(state, newInput) {
    state.searchInput = newInput;
  },
  setSelectedSort(state, newSelectedSort) {
    state.options.selectedSort = newSelectedSort;
  },
  setselectedLimit(state, newSelectedLimit) {
    state.options.selectedLimit = newSelectedLimit;
  },
  setNewPage(state, newPage) {
    state.options.currentPage = newPage;
  },
  setNewTab(state, newTab) {
    state.tabs.selected = newTab;
  },
  addFilter(state, filter) {
    const existing = state.filters.selected.find(e => e.category === filter.category);
    if (existing) {
      const index = state.filters.selected.findIndex(e => e.category === filter.category);
      state.filters.selected.splice(index, 1);
    }

    state.filters.selected.push(filter);
  },
  removeFilter(state, filter) {
    const existing = state.filters.selected.find(e => e.category === filter.category);
    if (existing) {
      const index = state.filters.selected.findIndex(e => e.category === filter.category);
      state.filters.selected.splice(index, 1);
    }
  },
  emptySelectedFilter(state) {
    state.filters.selected = [];
  }
};

const actions = {
  fetchSearchSuggestions({ commit, state }, input) {
    return new Promise((resolve, reject) => {
      try {
        const queryInput = input ? input : state.searchInput;
        Vue.http.get(`${wwfconfigs.FUNNELBACK_SEARCH_URL}/suggest.json?collection=${wwfconfigs.FUNNELBACK_COLLECTION}&partial_query=${queryInput}`).then(response => {
          resolve(response.body);
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  fetchSearchResultsWithPrebuiltQuery({ commit, state, dispatch }, query) {
    return new Promise(async (resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.FUNNELBACK_SEARCH_URL}/search.json${query}`).then(response => {
          dispatch('processSearchResponse', response.body).then(() => resolve(response.body));
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  fetchSearchResults({ commit, state, dispatch }, userQuery) {
    return new Promise(async (resolve, reject) => {
      try {
        if (state.searchInput && state.searchInput.length > 0) {
          // Set variables
          const urlQuery = userQuery ? userQuery : state.searchInput;
          const startRank = (state.options.selectedLimit * (state.options.currentPage - 1)) + 1;
          const tabParam = state.tabs.selected.queryStringParam ? state.tabs.selected.queryStringParam : '';

          // Build the query
          let query = `collection=${wwfconfigs.FUNNELBACK_COLLECTION}&query=${urlQuery}`;
          query += `&sort=${state.options.selectedSort.type}`;
          query += `&num_ranks=${state.options.selectedLimit}`;
          query += `&start_rank=${startRank}`;
          query += `&${tabParam}`;

          for (const f of state.filters.selected) {
            query += `&${f.queryStringParam}`;
          }
          console.log('query', query);

          Vue.http.get(`${wwfconfigs.FUNNELBACK_SEARCH_URL}/search.json?${query}`).then(response => {
            dispatch('processSearchResponse', response.body).then(() => resolve(response.body));
          }, error => {
            reject(error);
          });
        } else {
          resolve({});
        }
      } catch (err) {
        reject(err);
      }
    });
  },
  processSearchResponse({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      try {
        // EXTRACT DATA if we have results
        if (data.response.resultPacket.results && data.response.resultPacket.results.length > 0) {

          // Tabs
          const tabs = data.response.facets.find(e => e.name === 'Tabs');
          state.tabs.selection = tabs.allValues.map(e => ({
            label: e.label,
            numberOfResults: e.count,
            queryStringParam: e.queryStringParam
          }));

          // Pages
          state.options.totalResults = data.response.resultPacket.resultsSummary.fullyMatching;
          state.options.indexStart = data.response.resultPacket.resultsSummary.currStart;
          state.options.indexEnd = data.response.resultPacket.resultsSummary.currEnd;

          // Results
          state.results = data.response.resultPacket.results;
          for (const r of state.results) {
            r.date = moment(r.date).format('DD MMM YYYY');
          }

          // Fitlers
          const usedFilters = ['Format', 'Date'];
          state.filters.selection = data.response.facets
            .filter(e => usedFilters.includes(e.name))
            .map(e => {
              const label = e.name;
              const values = e.allValues.map(f => ({
                label: f.label,
                count: f.count,
                queryStringParam: f.queryStringParam,
                category: e.name
              }));
              if (values.length > 0) {
                return {
                  label,
                  values,
                };
              }
            })
            .filter(e => e);
          state.filters.selection.forEach(e => {
            console.log(e);
            e.values.sort((a, b) => {
              if (a.label === 'Uncertain') return 1;
              if (b.label === 'Uncertain') return -1;
              if (a.label > b.label) return -1;
              if (a.label < b.label) return 1;
              return 0;
            });
          })

          // Related searches
          state.relatedSearches = data.response.resultPacket.contextualNavigation.categories;
          for (const topic of state.relatedSearches) {
            for (const cluster of topic.clusters) {
              cluster.label = cluster.label.replace('...', ` ${state.searchInput} `);
            }
          }

        } else {
          // Reset to empty
          state.results = [];
        }
        resolve();
      } catch (err) {
        reject(err);
      }
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/search.js